import Locale from './Locale';

import styles from './header.module.css';

interface IHeaderProps {
  header?: string;
}

const Header: React.FC<IHeaderProps> = ({ header = 'Airport Limousine' }) => {
  return (
    <div className={styles.header}>
      <p className={styles.title}>{header}</p>
      <div className={styles.locale}>
        <Locale />
      </div>
    </div>
  );
};

export default Header;
